import { type UseQueryOptions, type UseQueryReturnType, useQuery } from '@tanstack/vue-query'
import { getAPIKeys } from '~~/src/api/api-key'
import type { APIKey } from '~~/src/api/api-key'

export const useGetApiKey = (
  options?: Omit<
    UseQueryOptions<
      APIKey[],
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<APIKey[], Error> => {
  return useQuery({
    queryKey: ['api-keys'],
    queryFn: async ({ signal }) => {
      const response = await getAPIKeys(signal)
      if (!response)
        throw new Error('No API keys found')

      return response.map(apiKey => ({ ...apiKey, showToken: false }))
    },
    ...options,
    placeholderData: [],
  })
}
